import { render, staticRenderFns } from "./AdminSelect.vue?vue&type=template&id=05e244aa&"
import script from "./AdminSelect.vue?vue&type=script&lang=ts&"
export * from "./AdminSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e244aa')) {
      api.createRecord('05e244aa', component.options)
    } else {
      api.reload('05e244aa', component.options)
    }
    module.hot.accept("./AdminSelect.vue?vue&type=template&id=05e244aa&", function () {
      api.rerender('05e244aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AdminSelect.vue"
export default component.exports